import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import {
  allowedLanguages,
  allowedTableColumnPropTypes,
  allowedTableItemPropTypes,
  allowedTablePartProps,
  allowedTranslationLabelProps
} from '../utils/allowedPropTypes';
import { translateText } from '../utils/functions';
import DataTableItem from './_DataTableItem';

const DataTableBody = props => {
  const {
    tableColumns,
    tableItems,
    languageCode,
    labels: {
      tableBody = {}
    } = {}
  } = props;

  const [columnCount, setColumnCount] = useState(0);

  useEffect(() => {
    const { length: passedColumnsLen } = tableColumns;
    if (columnCount !== passedColumnsLen && passedColumnsLen > 0) {
      setColumnCount(passedColumnsLen);
    }
  });

  if (tableItems.length < 1) {
    return (
      <tbody>
        <tr>
          <td className='cell-no-result' colSpan={columnCount}>
            {tableBody.noResult || translateText(
              'tableBody',
              'text-no-result',
              languageCode
            )}
          </td>
        </tr>
      </tbody>
    );
  }

  return tableItems.map(tableItemData => {
    const tableItemProps = {
      tableColumns,
      tableItemData,
      key: uuidv4()
    };

    return <DataTableItem {...tableItemProps} />;
  });
};

DataTableBody.propTypes = {
  ...allowedTablePartProps,
  tableItems: PropTypes.arrayOf(PropTypes.shape(allowedTableItemPropTypes)),
  tableColumns: PropTypes.arrayOf(PropTypes.shape(allowedTableColumnPropTypes)).isRequired,
  dataLabel: PropTypes.string.isRequired, // TODO: Get rid off this premature and overcomplicated optimization
  labels: PropTypes.shape(allowedTranslationLabelProps),
  languageCode: PropTypes.oneOf(allowedLanguages)
};

export default DataTableBody;